<script setup lang="ts">
defineProps<{
  title: string
  text: string
  icon: string

}>()
</script>

<template>
  <div flex flex-col gap-16px items-center py-24px>
    <UnoIcon :class="icon" h-48px w-48px about-icon-color />
    <div>
      <h2 heading1 font-700 text-neutral-50>
        {{ title }}
      </h2>
      <h3 text-neutral-300>
        {{ text }}
      </h3>
    </div>
  </div>
</template>
